import React, { useEffect, useState } from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import useAuth from '../../../../hooks/useAuth'
import IssueApi from '../../../../api/IssueApi'
import { IssueForm } from './IssueForm'
import { IssueSingleItem } from '@finance-lab/utils/types'

const issueApi = new IssueApi()

export function EditIssueForm({
    issueId,
    onChangeIssue,
}: {
    issueId?: string
    onChangeIssue: (issue: IssueSingleItem) => void
}) {
    const { isAuthenticated } = useAuth()
    const [issue, setIssue] = useState<IssueSingleItem | null>(null)

    const fetchData = React.useCallback(async () => {
        if (!isAuthenticated || !issueId) return
        const result = await issueApi.findByIssueId(issueId, { rawInvestorAmounts: true })

        if (result) {
            setIssue(result)
            onChangeIssue(result)
        }
    }, [isAuthenticated, issueId, onChangeIssue])

    useEffect(() => {
        void fetchData()
    }, [issueId, isAuthenticated, onChangeIssue, fetchData])

    if (!issue) return <LinearProgress />
    return <IssueForm issue={issue} reFetchData={fetchData} />
}
